import styles from './PercentageBarVisualization.module.scss';
import { Tooltip } from '@mui/material';

export interface PercentageBarSegment {
    name: string;
    /** Percentage width of this segment. E.g., 82 is 82% */
    width: number;
    backgroundColor: string;
    tooltip: string;
    className?: string;
}

export interface PercentageBarVisualizationProps {
    testId?: string;
    label: string;
    /** Percentage bar segments in the order they should appear left-to-right. In most cases, the sum of segment widths should probably be 100. */
    percentageBarSegments: PercentageBarSegment[];
}

export const PercentageBarVisualization = ({
    testId,
    label,
    percentageBarSegments,
}: PercentageBarVisualizationProps) => {
    return (
        <div
            data-testid={testId ?? 'PercentageBarVisualization'}
            className={styles.PercentageBarVisualization}
        >
            <label>{label}</label>

            <div className={styles.container}>
                {percentageBarSegments.map(
                    (segment: PercentageBarSegment, i: number) => {
                        return (
                            <Tooltip
                                arrow
                                key={`${segment.name}-${i}`}
                                title={segment.tooltip}
                            >
                                <div
                                    data-testid="Segment"
                                    style={{
                                        backgroundColor:
                                            segment.backgroundColor,
                                        width: `${segment.width}%`,
                                    }}
                                    className={segment?.className}
                                />
                            </Tooltip>
                        );
                    }
                )}
            </div>
        </div>
    );
};
